import { Navigate, Route, Routes } from 'react-router'
import ProtectedRoute from './ProtectedRoute'
import { MfaGuard } from '../../components/MfaGuard'
import {
  ChangePassword,
  DisableMFA,
  SetupMFA,
  SetupMFATOTP,
  SetupMFAWebAuthn,
  UserSettings,
} from '../../containers'
import {
  CHANGE_PASSWORD,
  DISABLE_MFA,
  SETTINGS,
  SETUP_MFA,
  SETUP_TOTP,
  SETUP_WEB_AUTHN,
} from '../../constants/routes'

const createRoutes = () => (
  <Routes>
    <Route element={<MfaGuard />}>
      <Route
        path={CHANGE_PASSWORD}
        element={<ProtectedRoute component={ChangePassword} />}
      />
      <Route
        path={SETUP_WEB_AUTHN}
        element={<ProtectedRoute component={SetupMFAWebAuthn} />}
      />
      <Route
        path={SETUP_TOTP}
        element={<ProtectedRoute component={SetupMFATOTP} />}
      />
      <Route
        path={SETUP_MFA}
        element={<ProtectedRoute component={SetupMFA} />}
      />
      <Route
        path={DISABLE_MFA}
        element={<ProtectedRoute component={DisableMFA} />}
      />
      <Route path={SETTINGS} element={<UserSettings />} />
      <Route path='*' element={<Navigate to={SETTINGS} replace />} />
    </Route>
  </Routes>
)

export default createRoutes
